// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"e1","speechCardBox":"e1","speech-img-box":"e2","speechImgBox":"e2","card-content":"e3","cardContent":"e3","card-src":"e4","cardSrc":"e4"};